<template>
    <div class="wall-button b-light" :class="{disabled: disabled}" @click="showWall()">
        <div class="position-relative">
            <i class="fas fa-comment-dots icon" v-if="$isPortal"></i>
            <i class="fas fa-comments icon" v-else></i>
            <span class="badge badge-danger badge-pill unread" v-if="unread > 0">{{ unreadNumber }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
.unread {
    position: absolute;
    top: 0;
    right: -20px;
}
.wall-button {
    border-radius: 50%;
    position: fixed;
    width: 50px;
    height: 50px;
    vertical-align: middle;
    bottom: 1rem;
    right: 1rem;
    display: flex;
    justify-content: center;
    cursor: pointer;
    .icon {
        margin-top: 18px;
    }
    &:hover {
        opacity: .8;
    }
    &.disabled {
        opacity: .5;
    }
}
</style>

<script>
export default {
    props: {
        unread: 0,
        ratingWall: null,
    },
    methods: {
        showWall() {
            if (!this.disabled) {
                this.$emit("showWall");
            } else if (!this.$store.state.user) {
                $("#r18-modal").modal();
            }
        }
    },
    computed: {
        disabled() {
            if (this.$isPortal
            || !this.ratingWall
            || this.$store.state.r18
            || this.ratingWall.id === 1
            || this.ratingWall.id <= this.$store.state?.user?.rating_id) {
                return false;
            }
            return true;
        },
        unreadNumber() {
            if (this.unread < 30) {
                return this.unread;
            }
            return "30+";
        }
    },
}
</script>